import type {AIGeneratorState} from 'src/types/ai-generator';
import type {AIGeneratorAction} from 'src/action-creators/ai-generator';

import {
  RECEIVE_AI_GENERATOR_INFO,
  UPDATE_AI_GENERATOR_INFO,
  RESET_AI_GENERATOR_STATE,
} from 'src/action-creators/ai-generator';


const initialState = {
  name: 'AI Prompt Node',
  prompt: ``,
  template: ``,
} as const;

export default (
  state: AIGeneratorState = initialState,
  action: AIGeneratorAction,
): AIGeneratorState => {
  switch (action.type) {
    case UPDATE_AI_GENERATOR_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RECEIVE_AI_GENERATOR_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_AI_GENERATOR_STATE:
      return {...initialState};
  }
  return state;
};
